module.exports = __webpack_public_path__ + "static/media/preloader-Big-DOMA-withText-Pet.aaf7fb62.gif";